<template>
    <div class="contacts-groups">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Criar Grupo</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <!-- Formulário de Edição e exclusáo -->
        <mu-form-group type="create"></mu-form-group>

    </div>
</template>

<script>
    export default {
        name: 'app-contacts-groups-create',
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Contatos',
                        route: 'app.contacts',
                        disabled: false
                    },
                    {
                        text: 'Grupos',
                        route: 'app.contacts.groups',
                        disabled: false
                    },
                    {
                        text: 'Criar Grupo',
                        disabled: true
                    }
                ]
            }
        }
    }
</script>
